import { render, staticRenderFns } from "./PartnerCalculator.vue?vue&type=template&id=1601cc96&scoped=true&"
import script from "./PartnerCalculator.vue?vue&type=script&lang=ts&"
export * from "./PartnerCalculator.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerCalculator.vue?vue&type=style&index=0&id=1601cc96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1601cc96",
  null
  
)

export default component.exports